var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "page-content" }, [
        _c(
          "div",
          {
            staticClass: "container-fluid",
            staticStyle: { "margin-top": "2rem" }
          },
          [
            _vm.initialized && _vm.headerDisplay
              ? _c("div", { staticClass: "row heading" }, [
                  _c("div", { staticClass: "col-sm-6" }, [
                    _c("h1", [
                      _vm._v(_vm._s(_vm.topic || _vm.breadcrumb[0].name))
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-sm-6" },
                    [
                      _c("toplevel-toolbar-component", {
                        attrs: {
                          content: _vm.topLevelContent,
                          config: _vm.topLevelConfig,
                          timestamp: _vm.localTimestamp,
                          changeUrl: _vm.changeUrl,
                          changeQuery: _vm.changeQuery,
                          changeSection: _vm.changeSection,
                          addNotification: _vm.addNotification
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("notifications", {
              attrs: {
                group: "notification",
                position: "top center",
                classes: "vue-notification",
                max: 2
              }
            }),
            _vm._v(" "),
            !_vm.initialized
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      position: "absolute",
                      left: "55%",
                      top: "10%"
                    }
                  },
                  [_c("vue-spinner")],
                  1
                )
              : _c("b-card", { attrs: { "no-body": "" } }, [
                  _c("div", { staticClass: "tabs" }, [
                    _c(
                      "div",
                      {
                        class: [
                          "card-header",
                          _vm.sections.length == 1 ? "hide" : ""
                        ]
                      },
                      [
                        _c(
                          "ul",
                          {
                            staticClass: "nav nav-tabs card-header-tabs",
                            attrs: { role: "tablist", tabindex: "0" }
                          },
                          _vm._l(_vm.sections, function(section) {
                            return _vm.isSectionEnabled(
                              _vm.topLevelType,
                              section.name
                            )
                              ? _c(
                                  "li",
                                  {
                                    key: section.name + section.link,
                                    class: ["nav-item"],
                                    attrs: { role: "presentation" }
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        class: [
                                          "nav-link",
                                          section.active ? "active" : ""
                                        ],
                                        attrs: { role: "tab", tabindex: "-1" },
                                        on: {
                                          click: function($event) {
                                            return _vm.changeTab(section)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(
                                              _vm.__(
                                                section.label || section.name,
                                                ["titleCase"]
                                              )
                                            )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          }),
                          0
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "tab-content tab-content-shadow" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "tab-pane card-body show fade active",
                            staticStyle: { "min-height": "2rem" },
                            attrs: { role: "tabpanel" }
                          },
                          [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-sm-6" }, [
                                _c("h2", { staticClass: "content-header" }, [
                                  _vm._v(
                                    "\n                                            " +
                                      _vm._s(
                                        _vm._.chain(_vm.breadcrumb)
                                          .last()
                                          .get("label")
                                          .value() ||
                                          _vm._.chain(_vm.breadcrumb)
                                            .last()
                                            .get("name")
                                            .str(["titleCase"])
                                            .value()
                                      ) +
                                      "\n                                        "
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.breadcrumbDisplay
                                  ? _c(
                                      "ul",
                                      { staticClass: "breadcrumb" },
                                      [
                                        _vm._l(_vm.breadcrumb, function(node) {
                                          return [
                                            node.link
                                              ? _c(
                                                  "li",
                                                  {
                                                    key: node.name + node.link
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.changeBreadcrumbLink(
                                                              node.link
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            node.label ||
                                                              _vm.__(
                                                                node.name,
                                                                ["titleCase"]
                                                              )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "li",
                                                  {
                                                    key: node.name + node.link
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        node.label ||
                                                          _vm.__(node.name, [
                                                            "titleCase"
                                                          ])
                                                      )
                                                    )
                                                  ]
                                                )
                                          ]
                                        })
                                      ],
                                      2
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-sm-6 text-right" },
                                [
                                  _vm.parent
                                    ? _c("content-toolbar-component", {
                                        attrs: {
                                          content: _vm.parent,
                                          children: _vm.content,
                                          timestamp: _vm.localTimestamp,
                                          changeUrl: _vm.changeUrl,
                                          changeQuery: _vm.changeQuery,
                                          changeSection: _vm.changeSection,
                                          componentName: "form-component",
                                          componentConfig: _vm.parentConfig,
                                          updateData: _vm.updateParent,
                                          deleteData: _vm.deleteParent,
                                          addNotification: _vm.addNotification
                                        },
                                        on: {
                                          "content::creating": _vm.doNothing,
                                          "content::created": _vm.doNothing,
                                          "content::updated": _vm.doNothing,
                                          "content::deleted":
                                            _vm.backToCollection
                                        }
                                      })
                                    : _c("content-toolbar-component", {
                                        attrs: {
                                          content: _vm.localContent,
                                          timestamp: _vm.localTimestamp,
                                          dirty: _vm.dirty,
                                          contentErrors: _vm.contentErrors,
                                          selected: _vm.selected,
                                          changeUrl: _vm.changeUrl,
                                          changeQuery: _vm.changeQuery,
                                          changeSection: _vm.changeSection,
                                          componentName: _vm.componentName,
                                          componentConfig: _vm.componentConfig,
                                          haltFetch: _vm.signalHaltFetch,
                                          createData: _vm.modifiedCreateData,
                                          updateBatch: _vm.modifiedUpdateBatch,
                                          updateData: _vm.modifiedUpdateData,
                                          deleteData: _vm.deleteData,
                                          addNotification: _vm.addNotification,
                                          commitQueue: _vm.commitQueue
                                        },
                                        on: {
                                          "content::creating":
                                            _vm.loadNewInstance,
                                          "content::created": _vm.doNothing,
                                          "content::updated":
                                            _vm.resetLocalState,
                                          "content::deleted":
                                            _vm.backToCollection,
                                          "content::selected":
                                            _vm.updateSelected
                                        }
                                      })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "tabs" }, [
                              _c(
                                "div",
                                {
                                  class: [
                                    "card-header card-header-inner",
                                    _vm.subSections.length == 1 ? "hide" : ""
                                  ]
                                },
                                [
                                  _c(
                                    "ul",
                                    {
                                      staticClass:
                                        "nav nav-tabs card-header-tabs",
                                      attrs: { role: "tablist", tabindex: "0" }
                                    },
                                    _vm._l(_vm.subSections, function(
                                      subSection
                                    ) {
                                      return _c(
                                        "li",
                                        {
                                          key:
                                            subSection.name + subSection.link,
                                          staticClass: "nav-item",
                                          attrs: { role: "presentation" }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              class: [
                                                "nav-link",
                                                subSection.active
                                                  ? "active"
                                                  : ""
                                              ],
                                              attrs: {
                                                role: "tab",
                                                tabindex: "-1"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.changeSubTab(
                                                    subSection
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                                    " +
                                                  _vm._s(
                                                    _vm.__(subSection.label, [
                                                      "titleCase"
                                                    ]) ||
                                                      _vm.__(subSection.name, [
                                                        "titleCase"
                                                      ])
                                                  )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "tab-content no-border" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "tab-pane card-body show fade active",
                                      attrs: { role: "tabpanel" }
                                    },
                                    [
                                      _vm.parent
                                        ? _c("content-toolbar-component", {
                                            attrs: {
                                              content: _vm.localContent,
                                              parent: _vm.parent,
                                              timestamp: _vm.localTimestamp,
                                              dirty: _vm.dirty,
                                              contentErrors: _vm.contentErrors,
                                              selected: _vm.selected,
                                              changeUrl: _vm.changeUrl,
                                              changeQuery: _vm.changeQuery,
                                              changeSection: _vm.changeSection,
                                              componentName: _vm.componentName,
                                              componentConfig:
                                                _vm.componentConfig,
                                              haltFetch: _vm.signalHaltFetch,
                                              createData:
                                                _vm.modifiedCreateData,
                                              updateBatch:
                                                _vm.modifiedUpdateBatch,
                                              updateData:
                                                _vm.modifiedUpdateData,
                                              deleteData: _vm.deleteData,
                                              addNotification:
                                                _vm.addNotification,
                                              commitQueue: _vm.commitQueue
                                            },
                                            on: {
                                              "content::creating":
                                                _vm.loadNewInstance,
                                              "content::created": _vm.doNothing,
                                              "content::updated":
                                                _vm.resetLocalState,
                                              "content::deleted":
                                                _vm.backToCollection,
                                              "content::selected":
                                                _vm.updateSelected
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.initialized
                                        ? [
                                            _vm.getComponentForType(
                                              _vm.fulltype
                                            )
                                              ? _c(
                                                  _vm.getComponentForType(
                                                    _vm.fulltype
                                                  ),
                                                  _vm._b(
                                                    {
                                                      key: _vm.resourcePath,
                                                      tag: "component",
                                                      attrs: {
                                                        loading: _vm.loading,
                                                        getData: _vm.getData,
                                                        createData:
                                                          _vm.modifiedCreateData,
                                                        updateBatch:
                                                          _vm.modifiedUpdateBatch,
                                                        updateData:
                                                          _vm.modifiedUpdateData,
                                                        deleteData:
                                                          _vm.deleteData,
                                                        replaceData:
                                                          _vm.replaceData,
                                                        changeUrl:
                                                          _vm.changeUrl,
                                                        changeQuery:
                                                          _vm.changeQuery,
                                                        changeSection:
                                                          _vm.changeSection,
                                                        addNotification:
                                                          _vm.addNotification,
                                                        haltFetch:
                                                          _vm.signalHaltFetch,
                                                        commitQueue:
                                                          _vm.commitQueue,
                                                        query: _vm.query,
                                                        timestamp:
                                                          _vm.timestamp,
                                                        content:
                                                          _vm.localContent,
                                                        resourceParams:
                                                          _vm.resourceParams
                                                      },
                                                      on: {
                                                        "content::initialized":
                                                          _vm.updateComponent,
                                                        "content::creating":
                                                          _vm.loadNewInstance,
                                                        "content::created":
                                                          _vm.doNothing,
                                                        "content::updated":
                                                          _vm.resetLocalState,
                                                        "content::changed":
                                                          _vm.updateLocalContent,
                                                        "content::deleted":
                                                          _vm.backToCollection,
                                                        "content::selected":
                                                          _vm.updateSelected
                                                      }
                                                    },
                                                    "component",
                                                    _vm.getConfigForType(
                                                      _vm.fulltype
                                                    ),
                                                    false
                                                  )
                                                )
                                              : _c("content-view-component", {
                                                  attrs: {
                                                    type: _vm.fulltype,
                                                    loading: _vm.loading,
                                                    showLoading:
                                                      _vm.currentSection !==
                                                      _vm.previousSection,
                                                    getData: _vm.getData,
                                                    createData:
                                                      _vm.modifiedCreateData,
                                                    updateBatch:
                                                      _vm.modifiedUpdateBatch,
                                                    updateData:
                                                      _vm.modifiedUpdateData,
                                                    deleteData: _vm.deleteData,
                                                    changeUrl:
                                                      _vm.changeUrlForSubSection,
                                                    changeQuery:
                                                      _vm.changeQuery,
                                                    changeSection:
                                                      _vm.changeSection,
                                                    addNotification:
                                                      _vm.addNotification,
                                                    commitQueue:
                                                      _vm.commitQueue,
                                                    pushQueue: _vm.pushQueue,
                                                    selected: _vm.selected,
                                                    resourceParams:
                                                      _vm.resourceParams,
                                                    section: _vm.section,
                                                    content: _vm.localContent,
                                                    parent: _vm.parent,
                                                    timestamp: _vm.timestamp,
                                                    query: _vm.query,
                                                    contentType:
                                                      _vm.contentType,
                                                    relationship:
                                                      _vm.relationship,
                                                    haltFetch:
                                                      _vm.signalHaltFetch
                                                  },
                                                  on: {
                                                    "content::initialized":
                                                      _vm.updateComponent,
                                                    "content::creating":
                                                      _vm.loadNewInstance,
                                                    "content::created":
                                                      _vm.doNothing,
                                                    "content::updated":
                                                      _vm.resetLocalState,
                                                    "content::changed":
                                                      _vm.updateLocalContent,
                                                    "content::deleted":
                                                      _vm.backToCollection,
                                                    "content::selected":
                                                      _vm.updateSelected
                                                  }
                                                })
                                          ]
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "col-sm-6 offset-sm-6 text-right"
                                },
                                [
                                  _c("content-toolbar-component", {
                                    attrs: {
                                      content: _vm.localContent,
                                      timestamp: _vm.localTimestamp,
                                      dirty: _vm.dirty,
                                      contentErrors: _vm.contentErrors,
                                      selected: _vm.selected,
                                      changeUrl: _vm.changeUrl,
                                      changeQuery: _vm.changeQuery,
                                      changeSection: _vm.changeSection,
                                      componentName: _vm.componentName,
                                      componentConfig: _vm.componentConfig,
                                      haltFetch: _vm.signalHaltFetch,
                                      createData: _vm.modifiedCreateData,
                                      updateBatch: _vm.modifiedUpdateBatch,
                                      updateData: _vm.modifiedUpdateData,
                                      deleteData: _vm.deleteData,
                                      commitQueue: _vm.commitQueue,
                                      updateParent: _vm.updateParent,
                                      addNotification: _vm.addNotification
                                    },
                                    on: {
                                      "content::creating": _vm.loadNewInstance,
                                      "content::created": _vm.doNothing,
                                      "content::updated": _vm.resetLocalState,
                                      "content::deleted": _vm.backToCollection
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  ])
                ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.initialized && _vm.openControlPanel
        ? _c("control-panel-component", {
            attrs: {
              content: _vm.localContent,
              user: _vm.user,
              timestamp: _vm.localTimestamp,
              dirty: _vm.dirty,
              contentErrors: _vm.contentErrors,
              selected: _vm.selected,
              changeUrl: _vm.changeUrl,
              changeQuery: _vm.changeQuery,
              changeSection: _vm.changeSection,
              componentName: _vm.componentName,
              componentConfig: _vm.componentConfig,
              haltFetch: _vm.signalHaltFetch,
              createData: _vm.modifiedCreateData,
              updateBatch: _vm.modifiedUpdateBatch,
              updateData: _vm.modifiedUpdateData,
              deleteData: _vm.deleteData,
              addNotification: _vm.addNotification,
              commitQueue: _vm.commitQueue
            },
            on: {
              close: function() {
                return (_vm.selected = [])
              },
              "content::creating": _vm.loadNewInstance,
              "content::created": _vm.doNothing,
              "content::deleted": _vm.backToCollection,
              "content::selected": _vm.updateSelected
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("global-file-modal-component")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3bbccc8a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbccc8a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/MainPanelComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3bbccc8a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/MainPanelComponent.vue
// module chunks = 0